var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Rank"},[(_vm.me)?_c('my_rank',{attrs:{"info":_vm.myRank}}):_c('rank')],1)}
var staticRenderFns = []

export { render, staticRenderFns }